import type { ApiError } from "../api/client";

/**
 * Human-readable text for an ApiError. Bean-Validation errors (400 VALIDATION)
 * carry `details` as a field → message map (contract §0), so those are joined
 * inline; everything else falls back to the server message.
 */
export function formatApiError(e: ApiError): string {
  const details = detailsMap(e);
  if (e.code === "VALIDATION" && details) {
    const parts = Object.entries(details).map(([k, v]) => `${k}: ${v}`);
    if (parts.length) return parts.join("; ");
  }
  return e.message;
}

/** `details` typed as string[] in the client, but the sprint-1 contract sends objects too. */
export function detailsMap(e: ApiError): Record<string, string> | null {
  const d = e.details as unknown;
  if (d && typeof d === "object" && !Array.isArray(d)) return d as Record<string, string>;
  return null;
}
